(function(){
  var pequenas={'de':1,'da':1,'do':1,'e':1,'com':1,'em':1};
  function tc(t){return t.toLowerCase().replace(/(^|\s|-)(\S)/g,function(m,a,b){return a+b.toUpperCase();}).split(' ').map(function(w,i){return (i>0&&pequenas[w.toLowerCase()])?w.toLowerCase():w;}).join(' ');}
  function run(){document.querySelectorAll('.product-area__details__title, .product-area__details__title h1, .product-block .title').forEach(function(el){
    if(el.dataset.tc)return; var t=el.textContent.trim(); if(t && t===t.toUpperCase()){el.textContent=tc(t);} el.dataset.tc='1';});}
  if(document.readyState!=='loading')run();else document.addEventListener('DOMContentLoaded',run);
  document.addEventListener('shopify:section:load',run);
  var mo=new MutationObserver(function(){run();}); mo.observe(document.body,{childList:true,subtree:true});
})();

document.addEventListener('keydown',function(e){ if(e.key!=='Escape')return; var c=document.querySelector('.cc-popup--visible .cc-popup-close'); if(c){c.click();} var x=document.getElementById('cboxClose'); if(x&&document.getElementById('colorbox')&&document.getElementById('colorbox').style.display!=='none'){x.click();} });

(function(){
  var sc=document.getElementById('site-control'); if(!sc)return;
  if(document.body.classList.contains('template-index')||location.pathname==='/'){document.body.classList.add('casa40-home');}
  function onScroll(){ if(window.scrollY>40){sc.classList.add('casa40-scrolled');}else{sc.classList.remove('casa40-scrolled');} }
  window.addEventListener('scroll',onScroll,{passive:true}); onScroll();
  function fade(){ document.querySelectorAll('.product-block img:not(.casa40-fade), .casa40-ig__media img:not(.casa40-fade)').forEach(function(i){ i.classList.add('casa40-fade'); if(i.complete&&i.naturalWidth>0){i.classList.add('is-loaded');} else { i.addEventListener('load',function(){i.classList.add('is-loaded');},{once:true}); i.addEventListener('error',function(){i.classList.add('is-loaded');},{once:true}); } }); }
  fade(); new MutationObserver(fade).observe(document.body,{childList:true,subtree:true});
})();

/* Abertura: no desktop, mostra duas fotos por vez */
(function(){
  var hero=document.querySelector('.casa40-hero'); if(!hero) return;
  if(hero.classList.contains('casa40-hero--solo')) return; /* foto inteira: sem díptico */
  var slides=[].slice.call(hero.querySelectorAll('.casa40-hero__slide')); if(slides.length<2) return;
  var seg=parseFloat((hero.style.getPropertyValue('--c40-hero-dur')||'30s'))/Math.max(slides.length,1)*1000||5000;
  var mq=window.matchMedia('(min-width: 900px)'), timer=null, idx=0;
  function show(){ slides.forEach(function(s){s.classList.remove('is-on','is-left','is-right');});
    var a=slides[idx%slides.length], b=slides[(idx+1)%slides.length];
    a.classList.add('is-on','is-left'); b.classList.add('is-on','is-right'); idx=(idx+2)%slides.length; }
  function start(){ if(!mq.matches){ stop(); return; } hero.classList.add('js-duo'); show(); timer=setInterval(show, seg*2); }
  function stop(){ hero.classList.remove('js-duo'); if(timer){clearInterval(timer);timer=null;} slides.forEach(function(s){s.classList.remove('is-on','is-left','is-right');}); }
  start(); mq.addEventListener ? mq.addEventListener('change', start) : mq.addListener(start);
})();

/* Favoritos: coração na peça. A lista mora no navegador da cliente — sem login.
   Quem lê essa lista depois é a consultora, pelo WhatsApp, na página /pages/favoritos. */
(function(){
  var CHAVE='casa40_favoritos', TETO=60;

  function ler(){
    try { var l=JSON.parse(localStorage.getItem(CHAVE)||'[]'); return Array.isArray(l)?l:[]; }
    catch(e){ return []; }   /* navegação privada ou storage bloqueado: segue sem quebrar */
  }
  function gravar(l){ try{ localStorage.setItem(CHAVE, JSON.stringify(l)); }catch(e){} }
  function indice(l,id){ for(var i=0;i<l.length;i++){ if(String(l[i].id)===String(id)) return i; } return -1; }

  function avisar(){
    var n=ler().length;
    document.querySelectorAll('[data-casa40-fav-conta]').forEach(function(el){ el.textContent = n||''; });
    document.querySelectorAll('[data-casa40-fav-link]').forEach(function(el){ el.classList.toggle('tem-itens', n>0); });
    document.dispatchEvent(new CustomEvent('casa40:favoritos',{detail:{total:n}}));
  }

  /* Só escreve quando o valor muda de verdade. Escrever sempre acorda o
     MutationObserver lá embaixo, que chama pintar() de novo — laço infinito. */
  function pintar(){
    var l=ler();
    document.querySelectorAll('[data-casa40-fav]').forEach(function(b){
      var on = indice(l,b.dataset.id)>-1;
      if(b.classList.contains('is-on')!==on) b.classList.toggle('is-on',on);
      var ap = on?'true':'false';
      if(b.getAttribute('aria-pressed')!==ap) b.setAttribute('aria-pressed',ap);
      var t=b.querySelector('.casa40-fav__txt');
      if(t){
        var alvo = on ? (t.dataset.txtGuardado||'Guardada') : (t.dataset.txtGuardar||'Guardar');
        if(t.textContent!==alvo) t.textContent=alvo;
      }
    });
  }

  function alternar(b){
    var l=ler(), i=indice(l,b.dataset.id), entrou;
    if(i>-1){ l.splice(i,1); entrou=false; }
    else {
      l.unshift({ id:b.dataset.id, titulo:b.dataset.titulo, marca:b.dataset.marca,
                  tipo:b.dataset.tipo, preco:b.dataset.preco, url:b.dataset.url,
                  img:b.dataset.img, em:Date.now() });
      if(l.length>TETO) l.length=TETO;
      entrou=true;
    }
    gravar(l); pintar(); avisar();
    b.classList.toggle('casa40-fav--pulsa', entrou);
    if(entrou) setTimeout(function(){ b.classList.remove('casa40-fav--pulsa'); }, 500);
    /* manda pro GTM: dá pra ver no GA4 quais peças mais recebem coração */
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: entrou?'casa40_favorito_add':'casa40_favorito_remove',
      item_id:b.dataset.id, item_name:b.dataset.titulo, item_brand:b.dataset.marca,
      item_category:b.dataset.tipo, total_favoritos:l.length });
  }

  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[data-casa40-fav]');
    if(!b) return;
    e.preventDefault(); e.stopPropagation();   /* o card inteiro é um link: não deixa navegar */
    alternar(b);
  });

  /* o tema troca blocos por ajax (filtro, paginação, quick view): repinta quando mudar */
  function iniciar(){ pintar(); avisar(); }
  if(document.readyState!=='loading') iniciar(); else document.addEventListener('DOMContentLoaded', iniciar);
  document.addEventListener('shopify:section:load', iniciar);
  /* o tema troca blocos por ajax; observa, mas em fila e ignorando o que o próprio pintar mexe */
  var agendado=false, obs=new MutationObserver(function(){
    if(agendado) return; agendado=true;
    requestAnimationFrame(function(){ agendado=false; obs.disconnect(); pintar(); ligar(); });
  });
  function ligar(){ obs.observe(document.body,{childList:true,subtree:true}); }
  ligar();
  /* outra aba mexeu na lista */
  window.addEventListener('storage', function(e){ if(e.key===CHAVE){ pintar(); avisar(); } });

  window.Casa40Favoritos = { ler: ler, limpar: function(){ gravar([]); pintar(); avisar(); } };
})();

/* Página de produto (16/10). No celular, a barra de compra aparece sempre que o botão principal não está
   na tela (o tema só mostrava depois de passar dele, então a primeira tela era só a foto).
   Tamanho: com mais de um tamanho em estoque, nenhum vem marcado; a cliente escolhe antes de comprar. */
(function(){
  var bar=document.querySelector('.product-area__add-to-cart-xs'),
      btn=document.querySelector('.product-detail__form button[type="submit"]'),
      sec=document.querySelector('.section-product-template');
  if(bar&&btn&&'IntersectionObserver' in window){
    var visivel=false, depois=false;
    function pinta(){ var on=!visivel&&!depois; if(bar.classList.contains('casa40-sticky-on')!==on) bar.classList.toggle('casa40-sticky-on',on); }
    new IntersectionObserver(function(e){ visivel=e[0].isIntersecting; pinta(); }).observe(btn);
    if(sec) new IntersectionObserver(function(e){ depois=!e[0].isIntersecting&&e[0].boundingClientRect.top<0; pinta(); }).observe(sec);
  }

  if(/[?&]variant=/.test(location.search)) return;
  var wr=[].slice.call(document.querySelectorAll('.product-detail__form .selector-wrapper')).filter(function(w){
    return /^(tam|size)/i.test(w.getAttribute('data-option-name')||''); })[0];
  if(!wr) return;
  var sel=wr.querySelector('select');
  var dados=document.querySelector('[data-product-json], script[type="application/json"][data-product-json]');
  var livres=0;
  try{
    var p=JSON.parse((document.querySelector('#cc-product-json-'+(sel.id.split('-').pop()))||dados||{}).textContent);
    var i=p.options.map(function(o){return (o.name||o).toLowerCase();}).findIndex(function(n){return /^(tam|size)/.test(n);});
    var vist={}; p.variants.forEach(function(v){ if(v.available){ vist[v.options[i]]=1; } }); livres=Object.keys(vist).length;
  }catch(e){ livres=wr.querySelectorAll('.clickyboxes a:not(.unavailable)').length; }
  if(livres<2) return;
  var pendente=true;
  wr.classList.add('casa40-tam-pendente');
  var aviso=document.createElement('p'); aviso.className='casa40-tam-aviso'; aviso.textContent='Escolha o seu tamanho';
  wr.appendChild(aviso);
  var wa=document.querySelector('[data-casa40-whats]');
  function waSemTamanho(){ if(!wa) return;
    var txt='Olá! Vim pelo SITE da Casa 40 · Peça: '+wa.getAttribute('data-titulo')+' (ref. '+wa.getAttribute('data-ref')+'). Quero saber mais. '+wa.getAttribute('data-url');
    wa.href='https://wa.me/'+wa.getAttribute('data-numero')+'?text='+encodeURIComponent(txt); }
  waSemTamanho();
  /* captura: o tema para a propagação do clique no tamanho */
  wr.addEventListener('click',function(e){ if(e.target.closest('.clickyboxes a')){ pendente=false; wr.classList.remove('casa40-tam-pendente','casa40-tam-alerta'); } },true);
  document.addEventListener('click',function(e){
    if(!pendente) return;
    if(!e.target.closest('.product-detail__form [type="submit"], .product-area__add-to-cart-xs button')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    wr.classList.add('casa40-tam-alerta');
    var y=wr.getBoundingClientRect().top+window.scrollY-200; window.scrollTo({top:y,behavior:'smooth'});
  },true);
})();
